import ReactDOM from "react-dom";
export default function Modal({ open, onClose, children }) {
  if (!open) {
    return null;
  }
  const handleClick = (e) => {
    e.stopPropagation();
    onClose();
  };
  return ReactDOM.createPortal(
    <div onClick={handleClick} className="modal-backdrop">
      <div onClick={(e) => e.stopPropagation()} className="modal-content">
        {children}
      </div>
    </div>,
    document.getElementById("modals")
  );
}
